export enum ReassignDisputeMaxLengths {
  REASON_FOR_REASSIGNMENT = 500,
}
